/* One tab-local enquiry draft shared by the page and desktop presentation. */
(() => {
  'use strict';
  const forms = [...document.querySelectorAll('#PageOneQuote, #PageOneQuoteModalForm')];
  if (!forms.length) return;
  const storageKey = 'pageone.enquiry.v1';
  const lifetime = 2 * 60 * 60 * 1000;
  const limits = { name:120, company:160, email:254, phone:40, product:200, quantity:7, delivery_date:10, occasion:120, delivery_city:120, budget_per_gift:120, branding:500, body:5000, shortlist:5000 };
  const field = (form, key) => form.querySelector('[name="contact[' + key + ']"]');
  let syncing = false;
  let storageTimer;
  function readStored() {
    try {
      const value = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (!value || value.version !== 1 || !Number.isFinite(value.savedAt) || !value.fields || typeof value.fields !== 'object' || Date.now() - value.savedAt > lifetime || value.savedAt > Date.now() + 60000) {
        sessionStorage.removeItem(storageKey); return null;
      }
      return value;
    } catch (_) { return null; }
  }
  function values(form) {
    return Object.fromEntries(Object.entries(limits).map(([key, max]) => [key, String(field(form,key)?.value || '').slice(0,max)]));
  }
  function assign(control, value) {
    if (!control) return;
    if (control.tagName === 'SELECT' && value && ![...control.options].some(option => option.value === value)) {
      // Recovered product names are text, never HTML.
      if (control.name !== 'contact[product]') return;
      control.add(new Option(value, value));
    }
    control.value = value;
  }
  function boundedContext(context) {
    if (!context || !['single','shortlist'].includes(context.mode)) return null;
    const clip=(value,max)=>String(value || '').slice(0,max);
    return {mode:context.mode,product:clip(context.product,200),quantity:clip(context.quantity,7),branding:clip(context.branding,500),generatedMessage:clip(context.generatedMessage,5000),items:(Array.isArray(context.items)?context.items:[]).slice(0,50).map(item=>({title:clip(item.title,200),quantity:clip(item.quantity,7),palette:clip(item.palette,200),finish:clip(item.finish,200),unit:clip(item.unit,30)}))};
  }
  function persist(origin) {
    clearTimeout(storageTimer);
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({version:1,savedAt:Date.now(),origin:origin || readStored()?.origin || 'PageOneQuote',context:boundedContext(window.PageOneQuote?.getContext?.()),fields:values(forms.find(form=>form.id===origin)||forms[0])}));
    } catch (_) { /* Private mode/storage quota must never block an enquiry. */ }
  }
  function refreshSummary() {
    const summary = document.querySelector('.mobile-quote-selection');
    const form = forms.find(item=>item.id==='PageOneQuote');
    const context = window.PageOneQuote?.getContext?.();
    forms.forEach(item=>{
      const quantity=field(item,'quantity');
      if(!quantity)return;
      const perItem=context?.mode==='shortlist';
      quantity.required=!perItem;
      quantity.readOnly=perItem;
      const requiredNote=item.querySelector('.quote-required-note');
      if(requiredNote){
        if(!requiredNote.dataset.defaultHelp)requiredNote.dataset.defaultHelp=requiredNote.textContent;
        requiredNote.textContent=perItem?'Name, company, email and consent are required. Quantities are already recorded per item in your shortlist. Other fields are optional.':requiredNote.dataset.defaultHelp;
      }
      const help=quantity.getAttribute('aria-describedby')?.split(' ').map(id=>document.getElementById(id)).find(Boolean);
      if(help){
        if(!help.dataset.defaultHelp)help.dataset.defaultHelp=help.textContent;
        help.textContent=perItem?'Quantities are recorded per item in your shortlist. Edit them in the shortlist before requesting a quote.':help.dataset.defaultHelp;
      }
    });
    if (!summary || !form) return;
    if (context?.mode === 'shortlist' && context.items?.length) {
      summary.textContent = context.items.map(item => [item.title, item.quantity ? item.quantity + ' ' + (item.unit || 'units') : '', item.palette, item.finish].filter(Boolean).join(' · ')).join('; ');
    } else {
      const value = values(form);
      summary.textContent = [value.product, value.quantity ? value.quantity + ' ' + ([...document.querySelectorAll('.product-card[data-title]')].find(card=>card.dataset.title===value.product)?.dataset.unit || 'units') : '', value.branding].filter(Boolean).join(' · ');
    }
  }
  // Called after each intent and each edit; never cache a summary built at modal open.
  window.PageOneEnquiry = { refreshSummary };
  const resultForms = forms.filter(form=>form.querySelector('[data-enquiry-result]'));
  const stored = readStored();
  const succeeded = resultForms.some(form=>form.querySelector('[data-enquiry-result="success"]'));
  const explicitContext = window.PageOneQuote?.getContext?.();
  const hasExplicitIntent = !!explicitContext?.product;
  if (!succeeded && stored?.fields) {
    const recoveredContext=boundedContext(stored.context);
    if(!hasExplicitIntent && recoveredContext)window.PageOneQuote?.setContext?.(recoveredContext);
    forms.forEach(form=>Object.entries(limits).forEach(([key,max])=>{
      const control = field(form,key);
      if (!control || typeof stored.fields[key] !== 'string') return;
      // Keep Shopify's returned contact values if it supplied them on rejection.
      if (resultForms.includes(form) && ['name','email','body'].includes(key) && control.value) return;
      if(hasExplicitIntent && ['product','quantity','branding','shortlist'].includes(key))return;
      let value=stored.fields[key].slice(0,max);
      if(hasExplicitIntent && key==='body'){
        const old=stored.context?.generatedMessage;
        if(old && value.endsWith(old))value=value.slice(0,-old.length).trimEnd();
        value+=(value && explicitContext.generatedMessage?'\n\n':'')+(explicitContext.generatedMessage||'');
      }
      assign(control,value);
    }));
  }
  // Native Shopify response values belong to the submitted form, not a stale mirror.
  const returnedForm = resultForms.find(form=>form.id===stored?.origin) || resultForms[0];
  if(returnedForm && !succeeded) ['name','email','body'].forEach(key=>{
    const returned=field(returnedForm,key);
    if(returned?.value)forms.filter(form=>form!==returnedForm).forEach(form=>assign(field(form,key),returned.value));
  });
  forms.forEach(form=>{
    function edit(event) {
      if (syncing) return;
      const control = event.target;
      const key = /^contact\[([^\]]+)\]$/.exec(control.name || '')?.[1];
      if (!Object.hasOwn(limits,key)) return;
      syncing = true;
      forms.filter(other=>other!==form).forEach(other=>assign(field(other,key),control.value));
      syncing = false;
      if (['product','quantity','branding'].includes(key)) {
        const context=window.PageOneQuote?.getContext?.() || {};
        const next=key==='product'?{mode:'single',product:control.value,quantity:'',branding:'',items:[],generatedMessage:''}:{...context,[key]:control.value};
        window.PageOneQuote?.setContext?.(next);
      }
      if (control.validity?.valid && control.getAttribute('aria-invalid')==='true') control.removeAttribute('aria-invalid');
      refreshSummary();
      clearTimeout(storageTimer);
      storageTimer = setTimeout(()=>persist(form.id),150);
    }
    form.addEventListener('input',edit);
    form.addEventListener('change',edit);
    form.addEventListener('submit',()=>persist(form.id));
    form.addEventListener('invalid',event=>event.target.setAttribute('aria-invalid','true'),true);
    form.querySelectorAll('[data-enquiry-result="error"] a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{
      const target=document.getElementById(link.hash.slice(1));
      if(target){event.preventDefault();target.focus();}
    }));
  });
  document.addEventListener('pageone:quote-context',()=>{ refreshSummary(); persist(); });
  document.addEventListener('pageone:open-inline-quote',()=>requestAnimationFrame(refreshSummary));
  window.addEventListener('pagehide',()=>{if(!succeeded)persist();});
  refreshSummary();
  if (resultForms.length) {
    const preferred = resultForms.find(form=>form.id===stored?.origin) || resultForms.find(form=>form.id==='PageOneQuote') || resultForms[0];
    const result = preferred.querySelector('[data-enquiry-result]');
    if (succeeded) {
      clearTimeout(storageTimer);
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
    }
    requestAnimationFrame(()=>{
      const dialog=preferred.closest('dialog');
      if (dialog && !matchMedia('(max-width: 760px)').matches) {
        if (!dialog.open) dialog.showModal();
        result.focus({preventScroll:true});
        result.scrollIntoView({block:'nearest',behavior:'instant'});
      } else {
        // A response to a desktop submission can return at a phone width.
        const visible= forms.find(form=>form.id==='PageOneQuote')?.querySelector('[data-enquiry-result]') || result;
        if (visible.closest('dialog')) { if(!dialog.open)dialog.showModal(); }
        visible.focus({preventScroll:true});
        visible.scrollIntoView({block:'center',behavior:'instant'});
      }
    });
  }
})();
